module.exports = __webpack_public_path__ + "img/img-scholarshipprogram1@1x.3d38a4fc.jpg";